import { columnSummaryPayload } from "../modules/types/Dataset.model.ts";
import axiosInstance from "./axiosInstance.ts";

export const datasetService = {
  fetchDatasets: (skip = 0, limit = 10, page = 1) =>
    axiosInstance.get("api/v1/datasets/", {
      params: {
        skip,
        limit,
        page,
      },
      headers: {
        Accept: "application/json",
      },
    }),

  fetchValidDatasets: () =>
    axiosInstance.get("/api/v1/datasets/list-validated", {
      params: {
        skip: 0,
        limit: 100,
      },
      headers: {
        Accept: "application/json",
      },
    }),

  fetchPredictionDatasets: (dataset_id) =>
    axiosInstance.get(`/api/v1/datasets/${dataset_id}/prediction-dataset`),

  deleteDataset: (datasetId: number) =>
    axiosInstance.delete(`${"api/v1/datasets"}/${datasetId}`),
  DownloadError: (filePath: string) =>
    axiosInstance.get(`api/v1/datasets/download/?file_path=${filePath}`, {
      headers: {
        Accept: "application/json",
      },
    }),
  fetchDataSetView: (dataset_id: number) =>
    axiosInstance.get(`/api/v1/datasets/${dataset_id}/view`, {
      headers: {
        Accept: "application/json",
      },
    }),

  generateStatistics: (dataset_id: number) => {
    return axiosInstance.post(`/api/v1/datasets/${dataset_id}/statistics`, {
      headers: {
        Accept: "application/json",
      },
    })
  },

  fetchStatistics: (dataset_id: number) => {
    return axiosInstance.get(`/api/v1/datasets/${dataset_id}/statistics`, {
      headers: {
        Accept: "application/json",
      },
    })
  },

  fetchSummary: (payload: columnSummaryPayload) => {
    return axiosInstance.post(`/api/v1/datasets/chart?column_name=${payload?.column_name}&dataset_id=${payload?.dataset_id}`)
  },

  getDatasource: () => {
    return axiosInstance.get("api/v1/datalake/data-source-config")
  }
};
